// src/design/forms/datepicker/calendar-engine/utilities/range.ts
var e = (e, t, n = 1) => {
	let r = [];
	for (let i = e; i <= t; i += n) r.push(i);
	return r;
};
export { e as range };

//# sourceMappingURL=range.js.map